import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatActions from '@medsurf/flat-actions';

@Injectable()
export class FeedbackViewerFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Requests">

  requestSendFeedback(feedback: FlatModels.FeedbackViewerModels.FeedbackModel) {
    return this.store.dispatch(new FlatActions.FeedbackViewerActions.SendFeedback(feedback));
  }

  //</editor-fold>
}
